import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import ApiReportSetting from '../../Api/ApiReportSetting';
import ToastMsg from '../../Components/ToastMsg';
import { creators as ReportSettingActions } from '../../Reducers/Reporting/ReportSetting';

export function* getReportSetting() {
  try {
    const response = yield call(ApiReportSetting.getReportSetting);
    if (response.status === 200) {
      yield put(
        ReportSettingActions.reportSettingSuccess({
          siteSetting: response.data,
        }),
      );
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Get Report Setting',
            text: response.message,
          },
        },
      );
      yield put(ReportSettingActions.reportSettingFailure(response.message));
    }
  } catch (e) {
    yield put(ReportSettingActions.reportSettingFailure(e));
  }
}

export function* updateReportSetting({ payload }) {
  try {
    const response = yield call(ApiReportSetting.updateReportSetting, payload);
    if (response.status === 200) {
      yield put(
        ReportSettingActions.reportSettingSuccess({
          siteSetting: response.data,
        }),
      );
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'UpdateReport Setting',
            text: response.message,
          },
        },
      );
      yield put(ReportSettingActions.reportSettingFailure(response.message));
    }
  } catch (e) {
    yield put(ReportSettingActions.reportSettingFailure(e));
  }
}
